export default "__VITE_ASSET__BEqRFpFo__"